import { render, staticRenderFns } from "./session-updates.vue?vue&type=template&id=9c21dd68"
import script from "./session-updates.vue?vue&type=script&lang=js"
export * from "./session-updates.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports